module.exports = __webpack_public_path__ + "static/media/ajinkya.fc15c9e0.jpg";